import PlaceholderPage from '@/app/pages/PlaceholderPage';
import { systemAdminNavItems, type AdminNavItem, type AdminSurfaceConfig } from '@/app/surface';
import {
  SystemDashboardContent,
  SystemAnalyticsPage,
  SystemAuditPage,
  SystemFranchisesPage,
  SystemOcPage,
  SystemSettingsPage,
  SystemStoresPage,
  SystemUsersPage,
} from '@/app/features/system-admin/pages';

export const surfaceConfig: AdminSurfaceConfig = {
  surface: 'system_admin',
  allowedRole: 'platform_admin',
  title: 'Octopus 시스템 관리자',
  shortTitle: 'System Admin',
  badge: 'SYS',
  loginTitle: '시스템 관리자 로그인',
  loginDescription: '플랫폼 전체 운영, OC, 감사 로그, 설정을 관리합니다.',
  usernameLabel: '관리자 ID',
  usernamePlaceholder: 'platform_admin_test',
  homePath: '/',
  navItems: systemAdminNavItems,
};

export function getSurfaceRouteElement(item: AdminNavItem, config: AdminSurfaceConfig) {
  switch (item.path) {
    case '/franchises':
      return <SystemFranchisesPage />;
    case '/stores':
      return <SystemStoresPage />;
    case '/users':
      return <SystemUsersPage />;
    case '/oc':
      return <SystemOcPage />;
    case '/audit':
      return <SystemAuditPage />;
    case '/settings':
      return <SystemSettingsPage />;
    case '/analytics':
      return <SystemAnalyticsPage />;
    default:
      return <PlaceholderPage item={item} surfaceConfig={config} />;
  }
}

export function getSurfaceDashboardElement() {
  return <SystemDashboardContent />;
}
